// React
import React from "react";
// React
// CSS
import styles from "./LessonStatus.module.css";
// CSS
// Icons
import { BiBookOpen, BiArrowBack } from "react-icons/bi";
// Icons
// Modules
import { useNavigate } from "react-router-dom";
import { _parser } from "../../../Utils/_parser";
// Modules

type LessonStatusProps = {
  customData?: string;
};

const LessonStatus: React.FunctionComponent<LessonStatusProps> = ({
  customData
}) => {
  // console.log("data ", data);

  const navigate = useNavigate();
  const data = _parser(
    localStorage.getItem("lessonData")
      ? localStorage.getItem("lessonData")
      : JSON.stringify({
          url: "",
          title: "",
          subjectName: "",
        })
  );
  return (
    <div
      className={`${styles.lessonStatusContainer} flex flex-row-reverse items-center justify-start w-full bg-white p-3 rounded-lg relative dark:!text-black`}
    >
      <BiArrowBack
        className="absolute top-1/4 left-3 text-2xl"
        onClick={() => {
          navigate(-1);
        }}
      />
      <div className="relative  w-20 h-20 flex items-center justify-center ml-2dark:!text-black ml-2">
        <img
          src={data.url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
          alt=""
          className={`${styles.lessonImage}  ml-2 p-1 mt-1 mr-1`}
          style={{ width: "70%", height: "70%" }}
        />

        <span
          className="absolute top-0 left-0 w-full h-full z-10 rounded-full "
          style={{
            border: ` 1px solid rgb(126, 58, 229)`,
          }}
        ></span>
      </div>
      <div
        className={`${styles.lessonData} flex flex-col items-center justify-end w-max dark:!text-black`}
      >
        <p className="flex flex-row items-center justify-end w-full dark:!text-black">
          <span>
            <BiBookOpen />
          </span>
          <span className="dark:!text-black">{data.title}</span>
        </p>
      </div>
    </div>
  );
};

export default LessonStatus;
